// ─────────────────────────────────────────────────────────────
// TwoPaneLayout.js - Two-pane layout for co-pilot right pane UX
// Left pane: Queue visualization, Right pane: Processing component
// ─────────────────────────────────────────────────────────────

import React from 'react';
import { Box, Transition, Grid, Card } from '@mantine/core';

export default function TwoPaneLayout({ 
  leftContent, 
  rightContent,
  phase,
  showRightPane = true
}) {
  return (
    <Box h="100vh" p="xl">
      <Grid gutter="lg" h="100%">
        {/* Left Column - Queue (always visible, adapts width) */}
        <Grid.Col span={showRightPane ? 5 : 12}>
          <Card 
            withBorder 
            radius="md" 
            p="lg" 
            h="100%"
            sx={(theme) => ({
              backgroundColor: theme.colors.gray[0],
              overflowY: 'auto'
            })}
          >
            {leftContent}
          </Card>
        </Grid.Col>

        {/* Right Column - Processing (slides in from right) */}
        <Transition mounted={showRightPane} transition="fade-left" duration={400} timingFunction="ease">
          {(styles) => (
            <Grid.Col span={7} style={styles}>
              <Card withBorder radius="md" p="lg" h="100%">
                {rightContent}
              </Card>
            </Grid.Col>
          )}
        </Transition>
      </Grid>
    </Box>
  );
}